import { createOpenStore } from "stores/createOpenStore";

export const useTableShareStore = createOpenStore<{
  tableId: string;
  tableName: string;
  version: number;
}>();
